import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Grid,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { withFirebase } from "../Firebase";
import { useError } from "../ErrorProvider";
import { PageHeader, EmptyState, CardSkeleton } from "../UI";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  center: {
    margin: "0 auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600,
  },
}));

const DashboardHelpBase = ({ firebase }) => {
  const classes = useStyles();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showError } = useError();

  useEffect(() => {
    firebase
      .faq()
      .then((collection) => {
        let temp = [];
        collection.forEach((doc) => {
          temp.push(doc.data());
        });
        temp.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        setQuestions(temp);
      })
      .catch((err) => {
        showError(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firebase]);

  return (
    <div>
      <PageHeader title="Help" quote="Save like a champion today" />
      <Container>
        <Grid container>
          <Grid item xs={12} md={10} className={classes.center}>
            {loading && <CardSkeleton rows={5} />}
            {!loading && questions.length === 0 && (
              <EmptyState
                title="No FAQs yet"
                message="Check back soon — answers to common questions will appear here."
              />
            )}
            {!loading &&
              questions.map((question) => {
                return (
                  <Accordion key={question.sequence}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography className={classes.heading}>
                        {question.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>{question.text}</AccordionDetails>
                  </Accordion>
                );
              })}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

const DashboardHelp = withFirebase(DashboardHelpBase);

export default DashboardHelp;
